var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_component-login" },
    [_c(_vm.componentName, { tag: "component", staticClass: "_login-wrap" })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }